"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHead = exports.PageHeadContext = void 0;

var react_1 = __importDefault(require("react"));

var react_helmet_1 = require("react-helmet");

exports.PageHeadContext = react_1.default.createContext(undefined);

function PageHead(_ref) {
  var _title = _ref.title,
      children = _ref.children;

  var _ref2 = react_1.default.useContext(exports.PageHeadContext) || {},
      titleSuffix = _ref2.titleSuffix;

  var titleSegments = _title.split(' - ');

  if (titleSuffix && !titleSegments.includes(titleSuffix)) titleSegments.push(titleSuffix);
  var title = titleSegments.join(' - ');
  return react_1.default.createElement(react_helmet_1.Helmet, null, react_1.default.createElement("title", null, title), react_1.default.createElement("meta", {
    name: 'og:title',
    content: title
  }), react_1.default.createElement("meta", {
    name: 'og:title',
    content: title
  }), children);
}

exports.PageHead = PageHead;